// eslint-disable-next-line no-shadow
export enum TWA_EVENTS {
  CHECK_CONTACT_PERMISSION = 'checkContactPermission',
  CHECK_NOTIF_PERMISSION = 'checkNotifPermission',
  LOGOUT = 'logout',
  OPEN_FILE = 'openFile',
  SYNC_CONTACT = 'syncContacts',
  AUTH_TOKEN = 'auth_token',
  EDIT_NOTIFICATION = 'EDIT',
  DELETE_NOTIFICATION = 'DELETE',
  SEEN_NOTIFICATION = 'SEEN',
  PING = 'Ping',
  END_ONGOING_CALL = 'endOngoingCall',
  REJECT_INCOMING_CALL = 'rejectIncomingCall',
  SHOW_INCOMING_CALL_NOTIFICATION = 'showIncomingCallNotification',
  SHOW_ONGOING_CALL_NOTIFICATION = 'showOngoingCallNotification',
}
